module.exports = __webpack_public_path__ + "static/media/0e546d61.jpg";